var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import { Grid, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Search } from '@material-ui/icons';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Cell from './Cell';
import DataTableCss from './css/DataTableCss';
import Table from './Table';

var DataTable = function (_Component) {
  _inherits(DataTable, _Component);

  function DataTable() {
    var _temp, _this, _ret;

    _classCallCheck(this, DataTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      cellConfig: [],
      datas: [],
      rowsPerPage: 5,
      page: 0,
      order: 'desc',
      orderBy: '',
      search: '',
      search_disabled: true,
      searchlabel: 'Rechercher',
      prevProps: null,
      hasInitialized: false,
      time_out_chrome_hack: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  DataTable.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    var _this2 = this;

    var followedFields = ['rowsPerPage', 'page', 'order', 'orderBy', 'search', 'cellConfig', 'search_disabled'],
        update = false;
    followedFields.forEach(function (k) {
      return update = !update ? _this2.state[k] !== nextState[k] : update;
    });
    if (!update) update = !DataTable.datasIsEquals(this.props.datas, nextProps.datas);
    return this.props.cancelUpdateCheck || update;
  };
  /**
   * Trace les changements de state
   */


  DataTable.prototype.componentWillUnmount = function componentWillUnmount() {
    var _this3 = this;

    var followedProperties = ['rowsPerPage', 'page', 'orderBy', 'order', 'search'];

    if (!!this.props.getStateOnUnmount) {
      var data = Object.keys(this.state).filter(function (key) {
        return followedProperties.includes(key);
      }).reduce(function (obj, key) {
        obj[key] = _this3.state[key];
        return obj;
      }, {});
      data.timestamp = new Date().getTime();
      this.props.getStateOnUnmount(data);
    }

    clearTimeout(this.time_out_chrome_hack);
  };
  /**
   * Lorsque le composant est monté on récupère toute la configuration des rows
   * @return {[type]} [description]
   */


  DataTable.prototype.componentDidMount = function componentDidMount() {
    var _this4 = this;

    var cellConfig = [],
        children = Array.isArray(this.props.children) ? this.props.children : [this.props.children];
    children.forEach(function (child) {
      if (!!child) {
        var isComponent = typeof child.type !== 'string' && React.Component.prototype.isPrototypeOf(child.type.prototype);
        var result = isComponent ? child.type === Cell : false;
        if (!result) throw new Error('Only Cell are allowed as child');
        cellConfig.push({
          className: !!child.props.className ? child.props.className : '',
          title: !!child.props.title ? child.props.title : null,
          datakey: !!child.props.datakey ? child.props.datakey : null,
          format: child.props.format ? child.props.format : _this4.getCellContent,
          sortable: !!child.props.sortable,
          searchable: !!child.props.searchable,
          isDate: !!child.props.isDate,
          useDataKeyOnSearch: !!child.props.useDataKeyOnSearch
        });
      }
    });
    var data = {
      cellConfig: cellConfig
    };

    if (!!this.props.initialValues) {
      data = _extends({}, data, this.props.initialValues, {
        hasInitialized: true
      });
    }

    this.setState(data); // let's fight Chrome (72+) autofill

    this.time_out_chrome_hack = setTimeout(function () {
      _this4.setState({
        search_disabled: false
      });
    }, 500);
  };
  /**
   * Retourne le nouveau state en fonction des nextProps
   * @param  {[type]} nextProps [description]
   * @param  {[type]} prevState [description]
   * @return {[type]}           [description]
   */


  DataTable.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var newState = {
      prevProps: nextProps
    };

    if (!DataTable.datasIsEquals(nextProps.datas, prevState.datas)) {
      newState = _extends({}, newState, {
        datas: nextProps.datas
      });
    }

    if (!!nextProps.searchlabel && nextProps.searchlabel !== prevState.searchlabel) {
      newState = _extends({}, newState, {
        searchlabel: nextProps.searchlabel
      });
    }

    if (!prevState.hasInitialized && !!nextProps.defaultSort && nextProps.defaultSort !== prevState.orderBy) {
      newState = _extends({}, newState, {
        orderBy: nextProps.defaultSort
      });
    }

    if (!prevState.hasInitialized && !!nextProps.sortType && nextProps.sortType !== prevState.order) {
      newState = _extends({}, newState, {
        order: nextProps.sortType
      });
    }

    var rowsPerPageProps = !!nextProps.rowsPerPage ? nextProps.rowsPerPage : !!nextProps.rowsPerPageOptions ? nextProps.rowsPerPageOptions[0] : prevState.rowsPerPage;

    if (!prevState.hasInitialized && !!nextProps.rowsPerPageOptions && rowsPerPageProps !== prevState.rowsPerPage) {
      newState = _extends({}, newState, {
        rowsPerPage: rowsPerPageProps
      });
    } // Ne pas mettre a jour le state par se biais si les props n'ont pas changés
    // Cette méthode est appelée suite a l'update du state également


    if (prevState.prevProps === nextProps) {
      newState = null;
    }

    return newState;
  };
  /**
   * Vérifie l'égalité de deux tableaux d'objets
   * @param  {[type]} a [description]
   * @param  {[type]} b [description]
   * @return {[type]}   [description]
   */


  DataTable.datasIsEquals = function datasIsEquals(a, b) {
    if (!a || !b) return false;
    return a.length === b.length && a.every(function (object, index) {
      return DataTable.isEquivalent(object, b[index]);
    });
  };
  /**
   * Vérifie l'égalité de deux objets
   * @param  {[type]}  a [description]
   * @param  {[type]}  b [description]
   * @return {Boolean}   [description]
   */


  DataTable.isEquivalent = function isEquivalent(a, b) {
    if (!a || !b) return false; // Create arrays of property names

    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b); // If number of properties is different,
    // objects are not equivalent

    if (aProps.length !== bProps.length) {
      return false;
    }

    for (var i = 0; i < aProps.length; i++) {
      var propName = aProps[i]; // If values of same property are not equal,
      // objects are not equivalent

      if (a[propName] !== b[propName]) {
        return false;
      }
    } // If we made it this far, objects
    // are considered equivalent


    return true;
  };
  /**
   * Retourne la valeur d'une Cell
   * @param  {[type]} data [description]
   * @param  {[type]} key [description]
   * @return {[type]}     [description]
   */


  DataTable.prototype.getCellContent = function getCellContent(data, key) {
    if (!data || !key) return null;
    var value = data;
    key.split('.').forEach(function (k) {
      if (value) value = value[k];
    });
    return value;
  };
  /**
   * Applique le filtre de la recherche
   * @param  {[type]} datas [description]
   * @return {[type]}       [description]
   */


  DataTable.prototype.filterOnSearch = function filterOnSearch(datas) {
    var _this5 = this;

    if (!this.props.showSearch || !this.state.search || this.state.search === '') return datas;
    var cellConfig = this.state.cellConfig,
        cellConfigSearchable = cellConfig.filter(function (conf) {
      return conf.searchable;
    });
    return datas.filter(function (data) {
      var find = false;

      _this5.state.search.split(' ').forEach(function (keyword, index) {
        if (keyword) {
          var keyWordFound = false;
          cellConfigSearchable.forEach(function (conf) {
            if (!keyWordFound) {
              var cellData = conf.useDataKeyOnSearch ? _this5.getCellContent(data, conf.datakey) : String(conf.format(data, conf.datakey));
              keyWordFound = cellData.toLowerCase().indexOf(keyword.toLowerCase()) > -1;
            }
          });
          find = index === 0 ? keyWordFound : keyWordFound && find;
        }
      });

      return find;
    });
  };
  /**
   * Filtre les les critère de trie
   * @param  {[type]} datas [description]
   * @return {[type]}       [description]
   */


  DataTable.prototype.filterSort = function filterSort(datas) {
    var _this6 = this;

    var _state = this.state,
        order = _state.order,
        orderBy = _state.orderBy,
        cellConfig = _state.cellConfig,
        conf = cellConfig.find(function (c) {
      return c.datakey === orderBy;
    });

    if (orderBy && conf) {
      return datas.sort(function (a, b) {
        var valueA = _this6.getCellContent(a, conf.datakey),
            valueB = _this6.getCellContent(b, conf.datakey);

        if (conf.isDate) {
          valueA = new Date(valueA).getTime();
          valueB = new Date(valueB).getTime();
        }

        if (conf.isBoolean) {
          if (order === 'asc') return valueA === valueB ? 0 : valueA ? -1 : 1;
          if (order !== 'asc') return valueA === valueB ? 0 : valueA ? 1 : -1;
        } else {
          if (valueA < valueB) return order === 'asc' ? 1 : -1;
          if (valueA > valueB) return order === 'asc' ? -1 : 1;
          return 0;
        }
      });
    }

    return datas;
  };
  /**
   * filtre les données
   * @return {[type]} [description]
   */


  DataTable.prototype.getDatasWithLimit = function getDatasWithLimit() {
    var _this7 = this;

    var _state2 = this.state,
        datas = _state2.datas,
        rowsPerPage = _state2.rowsPerPage,
        page = _state2.page,
        minData = page * rowsPerPage,
        maxData = (page + 1) * rowsPerPage - 1;
    datas = this.filterOnSearch(datas);
    datas = this.filterSort(datas);
    return datas.filter(function (d, i) {
      return i >= minData && i <= maxData || !_this7.props.showPagination;
    });
  };
  /**
   * Met à jour les données de trie
   * @param  {[type]} datakey [description]
   * @return {[type]}         [description]
   */


  DataTable.prototype.sortHandler = function sortHandler(datakey) {
    var orderBy = datakey;
    var order = 'desc';

    if (this.state.orderBy === orderBy && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({
      order: order,
      orderBy: orderBy
    });
  };
  /**
   * Ecoute l'évènement du changement de page
   * @param  {[type]} event [description]
   * @param  {[type]} page  [description]
   * @return {[type]}       [description]
   */


  DataTable.prototype.handleChangePage = function handleChangePage(event, page) {
    this.setState({
      page: page
    });
  };
  /**
   * Ecoute le changement du nombre de ligne par page
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */


  DataTable.prototype.handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    this.setState({
      rowsPerPage: event.target.value
    });
  };
  /**
   * Handler sur la recherche
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */


  DataTable.prototype.handleChangeSearch = function handleChangeSearch(event) {
    this.setState({
      search: event.target.value
    });
  };
  /**
   * retourne le bouton de recherche
   * @return {[type]} [description]
   */


  DataTable.prototype.getSearchField = function getSearchField() {
    var _props = this.props,
        classes = _props.classes,
        showSearch = _props.showSearch;
    if (!showSearch) return null;
    return React.createElement(Grid, {
      container: true,
      alignItems: 'flex-end'
    }, React.createElement(Grid, {
      xs: 12,
      sm: 12,
      md: 6,
      lg: 6,
      xl: 6,
      item: true
    }, this.insertExtraNodes('top-left')), React.createElement(Grid, {
      xs: 12,
      sm: 12,
      md: 6,
      lg: 6,
      xl: 6,
      item: true
    }, React.createElement(Grid, {
      item: true,
      className: classes.topRightExtraNode
    }, this.insertExtraNodes('top-right')), React.createElement(Grid, {
      item: true,
      className: classes.searchInput
    }, React.createElement(Grid, {
      container: true,
      spacing: 1,
      alignItems: 'flex-end'
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(Search, {
      className: classes.searchIcon
    })), React.createElement(Grid, {
      item: true
    }, React.createElement(TextField, {
      label: this.state.searchlabel,
      id: 'search-input',
      type: 'search',
      value: this.state.search,
      onChange: this.handleChangeSearch.bind(this),
      disabled: this.state.search_disabled
    }))))));
  };
  /**
   * rarjoute les elements extra dans le datatable
   * @param  {[type]} position [description]
   * @return {[type]}          [description]
   */


  DataTable.prototype.insertExtraNodes = function insertExtraNodes(position) {
    if (!this.props.extraNodes) return null;
    return this.props.extraNodes.filter(function (n) {
      return n.position === position;
    }).slice(0, 1).map(function (n, i) {
      return React.createElement(Grid, {
        item: true,
        key: i
      }, n.element);
    });
  };
  /**
   * Rendu Final
   * @return {[type]} [description]
   */


  DataTable.prototype.render = function render() {
    var _state3 = this.state,
        cellConfig = _state3.cellConfig,
        datas = _state3.datas,
        page = _state3.page,
        rowsPerPage = _state3.rowsPerPage,
        order = _state3.order,
        orderBy = _state3.orderBy;
    return React.createElement('div', {
      className: !!this.props.className ? this.props.className : ''
    }, this.getSearchField(), React.createElement(Table, {
      datas: this.getDatasWithLimit(),
      configRow: cellConfig,
      nbDatas: this.filterOnSearch(datas).length,
      showPagination: this.props.showPagination,
      handleChangePage: this.handleChangePage.bind(this),
      handleChangeRowsPerPage: this.handleChangeRowsPerPage.bind(this),
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order,
      sortHandler: this.sortHandler.bind(this),
      nodatalabel: this.props.nodatalabel,
      labelRowsPerPage: this.props.labelRowsPerPage,
      labelDisplayedRows: this.props.labelDisplayedRows,
      rowsPerPageOptions: this.props.rowsPerPageOptions,
      rowClassName: this.props.rowClassName
    }));
  };

  return DataTable;
}(Component);

DataTable.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  datas: PropTypes.array.isRequired,
  showPagination: PropTypes.bool,
  showSearch: PropTypes.bool,
  sortType: PropTypes.string,
  defaultSort: PropTypes.string,
  searchlabel: PropTypes.string,
  nodatalabel: PropTypes.string,
  className: PropTypes.string,
  labelRowsPerPage: PropTypes.string,
  labelDisplayedRows: PropTypes.func,
  rowsPerPageOptions: PropTypes.array,
  rowsPerPage: PropTypes.number,
  getStateOnUnmount: PropTypes.func,
  rowClassName: PropTypes.func,
  initialValues: PropTypes.object,
  extraNodes: PropTypes.arrayOf(PropTypes.object)
} : {};
export default withStyles(DataTableCss)(DataTable);